<template>
  <div class="bg-home">
    <div class="pt-5 center-card-home">
      <b-row class="justify-content-center">
        <b-col
          v-for="(item, index) in userParentModules"
          :key="index"
          lg="2"
          md="3"
          sm="3"
          cols="6"
          class="text-center mg-5 center-fix mt-3"
        >
          <router-link :to="{ name: item.route_name }" class="card-logo">
            <img
              :src="require(`@/assets/images/modules/${item.icons}`)"
              class="img-fluid"
              alt="logo"
            />
            <p class="font-name-home" style="margin-top: 8px">
              {{ $t(item.module_name) }}
            </p>
          </router-link>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuHidden: this.$store.state.appConfig.layout.menu.hidden,
    };
  },
  components: {},
  computed: {
    skin() {
      return this.$store.getters["appConfig/skin"];
    },
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },
    userParentModules() {
      if (this.currentUser) {
        if (Array.isArray(this.currentUser.arr_modules)) {
          return this.currentUser.arr_modules;
        }
        return JSON.parse(this.currentUser.arr_modules);
      } else {
        return [];
      }
    },
  },
  created() {
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);
  },
  destroyed() {
    this.$store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", false);
  },
};
</script>

<style scoped>
.bg-home {
  background-color: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: table;
  width: 100%;
}
.card-center {
  display: table-cell;
  vertical-align: middle;
}
.center-fix {
  display: flex;
  justify-content: center;
}
.font-name-home {
  font-family: "Rubik", sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 13px;
  letter-spacing: 0em;
  text-align: center;
}
.card-logo {
  transition: all 0.2s ease-in-out;
  width: 120px;
  height: 120px;
  border-radius: 10px;
  text-decoration: none !important;
  border: 1px solid #dbdbdb;
}

.card-logo img {
  height: 80%;
  border-radius: 10px;
  max-height: 90px;
}

.card-logo:hover {
  transform: scale(1.1);
  border: 1px solid #dbdbdb;
}
</style>